import type { IconButtonProps } from './types';
import * as React from 'react';
import { Popup } from 'semantic-ui-react';
import { Styled } from './index.styles';

export const IconButton: React.FC<IconButtonProps> = ({
  active = false,
  ariaLabel,
  className,
  compact = false,
  content,
  counter = 0,
  disabled,
  icon,
  loading = false,
  onClick,
  popupPosition: position,
  size,
  testid,
  variant = 'text',
  label,
}) => (
  <Styled.ButtonSafeArea
    {...{ className }}
    $disabled={disabled?.condition}
    {...(disabled?.condition && { title: disabled?.title })}
  >
    {!!counter && <Styled.Badge>{counter > 99 ? '99+' : counter}</Styled.Badge>}

    <Popup
      {...(variant === 'text' && { inverted: true })}
      {...{ content, position }}
      disabled={!content || disabled?.condition}
      style={{ fontSize: 14 }}
      trigger={
        <div className="flex flex-col gap-1">
          <Styled.Button
            {...(!loading && { onClick })}
            aria-label={ariaLabel ?? content}
            {...{ disabled: disabled?.condition, size }}
            $compact={compact}
            $variant={variant}
            $active={active}
            data-testid={testid}
            compact
            basic
          >
            {loading ? (
              <Styled.LoadingIcon {...{ icon: 'spinner', size }} />
            ) : (
              <Styled.Icon {...{ icon, size }} />
            )}
          </Styled.Button>
          {label}
        </div>
      }
    />
  </Styled.ButtonSafeArea>
);
